<template>
  <app-modal modal-id="gantt-modal"
             modal-size="medium"
             modal-alignment="top"
             @close-modal="closeModal">
    <template slot="header">
      <h5 class="modal-title" v-if="copy">
        {{  $t("gantt_copy") }}
      </h5>
      <h5 class="modal-title" v-else>
        {{ selectedUrl ? $t("edit_gantt") : $t("add_gantt") }}
      </h5>
      <button
          type="button"
          class="close outline-none"
          data-dismiss="modal"
          aria-label="Close">
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>
    <template slot="body">
      <form ref="form" v-if="dataLoaded" :data-url="selectedUrl ? selectedUrl : `crm/gantts`">
        <div class="form-group">
          <div class="row">
            <div class="mb-0 col-sm-3 d-flex align-items-center">
              <label>{{ $t("gantt_name") }}</label>
            </div>
            <div class="col-sm-9">
              <app-input
                  type="text"
                  :placeholder="$t('enter_name')"
                  name="name"
                  v-model="formData.name"
                  :required="true"
                  :error-message="$errorMessage(errors, 'name')"
              />
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="mb-0 col-sm-3 d-flex align-items-center">
              <label>{{ $t("gantt_type") }}</label>
            </div>
            <div class="col-9">
                <app-input
                  type="select"
                  list-value-field="name"
                  :placeholder="$t('enter_gantt_type')"
                  :list="ganttTypeList"
                  v-model="formData.gantt_type_id"
              />
              
            </div>
          </div>
        </div>

       
        

        
         
      </form>
      <app-overlay-loader v-else/>
    </template>
    <template slot="footer">
      <button
          type="button"
          class="btn btn-secondary mr-2"
          data-dismiss="modal"
          @click.prevent="closeModal"
      >
        {{ $t("cancel") }}
      </button>
      <button type="button" class="btn btn-primary" @click.prevent="submit">
        <span class="w-100">
          <app-submit-button-loader v-if="loading"></app-submit-button-loader>
        </span>
        <template v-if="!loading">{{ $t("save") }}</template>
      </button>
    </template>
  </app-modal>
</template>
<script>

import {FormSubmitMixin} from "@app/Mixins/Global/FormSubmitMixin";
import {mapGetters} from "vuex";
import { collect } from "@app/Helpers/Collection";
import moment from "moment";

export default {
  name: "GanttModal",
  mixins: [FormSubmitMixin],
  props: {
    copy: Boolean,
  },
  data() {
    return {
      dataLoaded: true,
      showChange:false,
      countryList: [],
      formData: {},
      addEditData: {
        created_by: user.id,
        deal: 2,
        status: 14
      },
      statusList: [
        {
          id: 14,
          name: this.$t('gantt_todo')
        },
        {
          id: 15,
          name: this.$t('gantt_done')
        },

      ],
     
     
    };
  },
  computed: {
    ...mapGetters({
      ownerList: "getOwner",
      ganttTypeList: "ganttType",
	 
	 
    }),

  },
  methods: {


    beforeSubmit() {
      this.loading = true;
    },
    submit() {
    
      


      this.addEditData.name = this.formData.name;
      this.addEditData.created_by = this.formData.created_by;
      
      this.addEditData.status_id = this.formData.status_id;
      this.addEditData.copy = this.copy;


   
      
      this.save(this.addEditData);
    },

   
    afterSuccessFromGetEditData(response) {
        
      this.formData = response.data;
      this.dataLoaded = true;
                  
                  
  
    
    },
  },
  mounted() {

    this.$store.dispatch("ganttType");

  },
};
</script>
